<template>
  <span class="label-toast">
    <span v-for="(m, index) in messages" v-if="showAll || index === 0">
      {{ m }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'label-toast',
  props: {
    toast: String,
    showAll: Number,
  },
  computed: {
    messages() {
      return this.toast ? this.toast.split(/\u001E/g) : [];
    },
  },
};
</script>

<style scoped lang="scss">
.label-toast {
  color: #71757e;
  font-size: 24px;
}
</style>
